export default __webpack_public_path__ + "static/media/logo_nav.cd8e91fc.png";